import { inject, observer } from "mobx-react";
import { InputText } from "primereact/inputtext";
import { OrderList } from "primereact/orderlist";
import { Sidebar } from "primereact/sidebar";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import FilialSideBar from "./FilialSideBar";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const categories = new Set(["698c2e49c4d1ec53a29d182c"]);

function extractGeoArrays(geoObject = {}) {
    const regionIds = [];
    const cityIds = [];
    const metroStationIds = [];

    for (const regionId in geoObject) {
        if (!Object.hasOwn(geoObject, regionId)) continue;
        regionIds.push(regionId);

        const regionContent = geoObject[regionId];

        // Обработка городов
        if (regionContent.cities && typeof regionContent.cities === "object") {
            for (const cityId in regionContent.cities) {
                if (Object.hasOwn(regionContent.cities, cityId)) {
                    cityIds.push(cityId);
                }

                const cityContent = regionContent.cities[cityId];

                if (cityContent?.metroStations && typeof cityContent?.metroStations === "object") {
                    for (const metroId in cityContent.metroStations) {
                        if (Object.hasOwn(cityContent.metroStations, metroId)) {
                            metroStationIds.push(metroId);
                        }
                    }
                }
            }
        }

        // Обработка станций метро
        if (regionContent.metroStations && typeof regionContent.metroStations === "object") {
            for (const metroId in regionContent.metroStations) {
                if (Object.hasOwn(regionContent.metroStations, metroId)) {
                    metroStationIds.push(metroId);
                }
            }
        }
    }

    return { regionIds, cityIds, metroStationIds };
}

const ReorderList = inject("mainStore")(
    observer(({ mainStore, onChange, items = [], defaultValue = null, onDelItem = () => {}, disabled, changeableData }) => {
        const [visible, setVisible] = useState(false);

        const detailData = mainStore.getMainStore("detailData");
        const offer = mainStore.getMainStore("defaultOffer");
        const { firstParam, secondParam } = useParams();
        const isCategories = detailData?.vendor?.categoriesIds?.some((item) => categories.has(item));

        const { regionIds, cityIds, metroStationIds } = extractGeoArrays(detailData?.geoObject || offer?.geoObject);

        useEffect(() => {
            if (!items.length && defaultValue) {
                addItem(defaultValue);
            }
        }, []);

        useEffect(() => {
            if (!detailData?.geoObject && detailData.addressId) {
                removeItem("filial");
            }
        }, [detailData?.geoObject]);

        useEffect(() => {
            if (items.length === 1 && items[0]?.type === "phone") {
                mainStore.setMainStore("detailData.mailOptions.notSend", true);
            }
        }, [items]);

        useEffect(() => {
            return () => {
                mainStore.setMainStore("defaultOffer", {});
            };
        }, []);

        const btns = [
            {
                label: "Добавить почту",
                type: "email",
                value: {
                    active: true,
                    isVerified: false,
                    key: "email",
                    placeholder: "Ваша почта",
                    require: true,
                    title: "Почта",
                    type: "email",
                },
            },
            {
                label: "Добавить имя",
                type: "name",
                value: {
                    active: true,
                    isVerified: false,
                    key: "name",
                    placeholder: "Ваше имя",
                    require: true,
                    title: "имя",
                    type: "name",
                },
            },
            {
                label: "Добавить телефон",
                type: "phone",
                value: {
                    active: true,
                    isVerified: true,
                    key: "phone",
                    placeholder: "Ваш телефон",
                    require: true,
                    title: "Телефон",
                    type: "phone",
                },
            },
            {
                label: "Добавить город",
                type: "city",
                value: {
                    active: true,
                    isVerified: false,
                    key: "city",
                    placeholder: "Выберите город",
                    require: true,
                    title: "Город",
                    type: "city",
                    onClick: (el) => {
                        addItem(el);
                    },
                },
            },
            {
                label: "Добавить выбор метро",
                type: "metro",
                value: {
                    active: true,
                    isVerified: false,
                    key: "metro",
                    placeholder: "Выберите станцию метро",
                    require: true,
                    title: "Город",
                    type: "metro",
                    onClick: (el) => {
                        addItem(el);
                    },
                },
            },
            {
                label: "Добавить филиал / кастомное поле",
                type: "filial",
                value: {
                    active: true,
                    isVerified: false,
                    key: "filial",
                    placeholder: "Выберите филиал",
                    require: true,
                    title: "Филиал",
                    type: "filial",
                    disable: !items.some((s) => s.type == "city"),
                    onClick: (el) => {
                        addItem(el);
                        setVisible(true);
                    },
                },
            },
        ];

        const addItem = (value) => {
            onChange([...items, value]);
        };

        const removeItem = async (type) => {
            if (disabled) return;
            let toRemove = new Set([type]);

            if (type === "city") toRemove.add("filial");

            if (["city", "filial"].includes(type)) {
                if (detailData.addressId) {
                    await mainStore.putByUrl(`promo/offeraddresses/${detailData.addressId}`, { title: "", addresses: [], offerId: secondParam }, "filial");
                }
            }

            const updated = items.filter((i) => !toRemove.has(i.type));

            onDelItem(type);
            onChange(updated);
        };

        const getPlaceholder = (type) => {
            switch (type) {
                case "email":
                    return "Ваша почта";
                case "name":
                    return "Ваше имя";
                case "phone":
                    return "+ 7 ___ ___ - __ - __";
                case "city":
                    return "Выберите город";
                case "metro":
                    return "Выберите станцию метро";
                case "filial":
                    return "Выберите филилал";
                default:
                    return;
            }
        };

        const itemTemplate = (item) => {
            const isDelete = isCategories;

            return (
                <div className="reorder-item" style={{ alignItems: "center" }}>
                    <InputText value={item.value} placeholder={getPlaceholder(item.type)} style={{ flex: 1 }} disabled />
                    {item.type !== "email" ? (
                        <i className="pi pi-trash" onClick={() => removeItem(item.type)} style={{ color: "#FF3D32" }} />
                    ) : !isDelete ? (
                        <i className="pi pi-trash" onClick={() => removeItem(item.type)} style={{ color: "#FF3D32" }} />
                    ) : null}
                    <i className="pi pi-sort-alt" style={{ color: "#424242" }} />
                    {item.type === "filial" && <i className="pi pi-cog" onClick={() => setVisible(true)} style={{ color: "#424242" }} />}
                </div>
            );
        };

        const vendorImgs = { coverMobile: changeableData?.vendor?.squareLogo };
        const image = changeableData?.coverMobile || vendorImgs?.coverMobile || offer?.vendor?.squareLogo;
        const isHit = changeableData?.offerOptions?.includes("hit");

        return (
            <div className="preview-container">
                <div className={`list-item__accordion ${isHit ? "hit" : ""}`}>
                    <div className="list-item__accordion__content">
                        <div className="list-item__accordion__logo">
                            <img className="logo_mobile" src={image} />
                        </div>
                        <div className="list-item__accordion__title-container">
                            <span
                                className={`list-item__accordion__title`}
                                dangerouslySetInnerHTML={{
                                    __html: offer?.title || changeableData.title,
                                }}
                            ></span>
                        </div>
                        {isHit ? <span className={`list-item__accordion__hit-label`}>хит</span> : null}
                    </div>

                    {items.some((s) => s.type == "phone") ? (
                        <div className={`steps`}>
                            <div className={`steps__line  steps__line_75"`}></div>
                            <div className="steps__wrapper">
                                <div className={`steps__step_active`}>
                                    <p>1</p>
                                </div>
                                <div className={`steps__step`}>
                                    <p>2</p>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <OrderList
                        value={items}
                        onChange={(e) => {
                            if (disabled) return;
                            onChange(e.value);
                        }}
                        itemTemplate={itemTemplate}
                        dragdrop
                        listStyle={{ height: "auto" }}
                    />

                    {btns.map((item) => {
                        if (items?.length ? items.some((i) => i.key === item.value.key) : false) return;

                        if (!cityIds?.length && item.type === "city") return null;
                        if (!metroStationIds?.length && item.type === "metro") return null;
                        if (!cityIds?.length && item.type === "filial") return null;

                        return (
                            <ButtonUI
                                key={item.type}
                                disabled={item.value.disable || disabled}
                                label={item.label}
                                icon="pi pi-plus-circle"
                                className="list-item__accordion__add p-button-outlined"
                                onClick={item.value.onClick ? () => item.value.onClick(item.value) : () => addItem(item.value)}
                            />
                        );
                    })}

                    <div className="form__button">
                        <ButtonUI label="Получить предложение" className="form__button_get-offer" />
                        <div className="share mobile">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.22825 5.2405V1.59961L15.598 7.97117L9.22825 14.3427V10.7018C4.67846 10.7018 2.55995 12.3996 0.399994 14.3996C1.83203 9.59961 3.27091 7.82045 4.63203 6.79961C5.99314 5.77877 7.22067 5.44016 9.22825 5.2405Z"
                                    fill="#1e22aa"
                                />
                            </svg>
                        </div>
                    </div>

                    <Sidebar visible={visible} position="right" onHide={() => setVisible(false)} className="filial__block" style={{ paddingBottom: 28 }}>
                        <FilialSideBar setVisible={setVisible} regionIds={regionIds} cityIds={cityIds} metroStationIds={metroStationIds} />
                    </Sidebar>
                </div>
            </div>
        );
    }),
);

export default ReorderList;
